// src/pages/Admin.tsx
import React from 'react';
import SuperAdminDashboard from './SuperAdminDashboard';

interface AdminProps {
  userRole?: string;
  tenantId?: string;
  userName?: string;
}

const Admin: React.FC<AdminProps> = ({ userRole, tenantId, userName }) => {
  // Use props directly - these are passed from App.tsx with correct values
  const role = userRole || '';
  const tenant = tenantId || '';
  const name = userName || 'Admin';

  console.log('Admin component received:', { role, tenant, name });

  return (
    <SuperAdminDashboard 
      userRole={role}
      tenantId={tenant}
      userName={name}
    />
  );
};

export default Admin;
